<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps" />
    <form
      class="content-plans-register-form"
      v-if="moods && moods.data && moods.data.length > 0"
      @submit.prevent="handleSubmit()"
    >
      <div class="row">
        <div class="col-12">
          <h2>Humores</h2>
          <div class="content-select-moods">
            <label>Selecione os humores: <span>*</span></label>
            <multiselect
              placeholder="Escreva para pesquisar"
              label="name"
              track-by="id"
              v-model="humorSelected"
              :options="moods.data"
              :multiple="true"
              :allow-empty="false"
              :disabled="isHumorSelected"
              @remove="removeHumorQuestion"
            >
              <template slot="singleLabel" slot-scope="props">
                <img
                  class="option__image"
                  :src="`data:image/jpg;base64,${props.option.picture}`"
                  alt="image emoticon"
                  title="image emoticon"
                />
                <span class="option__desc option--name">
                  <span class="option__title">{{ props.option.name }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <img
                  class="option__image"
                  :src="`data:image/jpg;base64,${props.option.picture}`"
                  alt="image emoticon"
                  title="image emoticon"
                />
                <span class="option__desc option--name">
                  <span class="option__title">{{ props.option.name }}</span>
                </span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h2>Perguntas/Respostas</h2>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <textarea
              name="question"
              value=""
              placeholder="Pergunta"
              v-model="question"
              :required="humor?.humorQuestions?.length === 0"
            />
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="content-input-default">
            <input
              name="question-options"
              value=""
              placeholder="Respostas"
              v-model="option"
              :required="humor?.humorQuestions?.length === 0"
            />
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <button
            class="btn-green--small"
            type="button"
            @click="toggleAnswers(option)"
          >
            Adicionar
          </button>
        </div>
        <div class="col-12 col-lg-8">
          <div
            class="content-resources-saved"
            v-for="(response, index) in arrayOptions"
            :key="index"
          >
            <p>{{ response.option }}</p>
            <button
              class="content-resources-saved-icon"
              type="button"
              @click="toggleAnswers(response)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="1em"
                viewBox="0 0 384 512"
              >
                <path
                  d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                />
              </svg>
            </button>
          </div>
        </div>
        <div class="col-12">
          <button
            class="btn-green--small btn--add--questions"
            type="button"
            @click="toggleQuestionsAndOptions()"
          >
            Salvar pergunta/respostas
          </button>
        </div>
      </div>
      <!-- Row das perguntas adicionadas -->
      <div
        class="row mt-5"
        v-if="humor.humorQuestions && humor.humorQuestions.length > 0"
      >
        <div class="col-12">
          <h2>Perguntas/Respostas Adicionados</h2>
        </div>
        <div class="col-12">
          <div class="row">
            <div
              class="col-6"
              v-for="question in humor.humorQuestions"
              :key="question.id_humor_question"
            >
              <div class="content-card-questions">
                <button
                  class="btn-remove"
                  type="button"
                  @click="toggleQuestionsAndOptions(question)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1em"
                    viewBox="0 0 384 512"
                  >
                    <path
                      d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                    />
                  </svg>
                </button>
                <div class="content-card-questions-element">
                  <h3>{{ question.question }}</h3>
                </div>
                <div class="content-card-questions-options">
                  <div class="title">
                    <h4>Respostas:</h4>
                  </div>
                  <div class="element">
                    <div
                      class="element-option"
                      v-for="option in question.data"
                      :key="option.id_humor_questions_option"
                    >
                      <p>{{ option.option }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!----------------------------------->
      <div class="row">
        <div class="col-12">
          <h2>Conteúdos Recomendados</h2>
        </div>
        <div class="col-12">
          <div class="content-select-moods">
            <label>Posts:</label>
            <multiselect
              group-values="posts"
              group-label="category_name"
              placeholder="Escreva para pesquisar"
              label="title_description"
              track-by="id_post"
              v-model="postSelected"
              :options="categoriesWithPosts"
              :group-select="true"
              :multiple="true"
              @remove="removeHumorPosts"
            >
              <template slot="singleLabel" slot-scope="props">
                <img
                  class="option__image option--image--width"
                  v-if="props.option.post_picture"
                  :src="`data:image/jpg;base64,${props.option.post_picture}`"
                  alt="image emoticon"
                  title="image emoticon"
                />
                <span class="option__desc">
                  <span class="option__title">{{
                    props.option.title_description
                  }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                {{ props.option.$groupLabel }}
                <img
                  class="option__image option--image--width"
                  v-if="props.option.post_picture"
                  :src="`data:image/jpg;base64,${props.option.post_picture}`"
                  alt="image emoticon"
                  title="image emoticon"
                />
                <span class="option__desc option--name">
                  <span class="option__title">{{
                    props.option.title_description
                  }}</span>
                </span>
              </template>
            </multiselect>
          </div>
        </div>
        <div class="col-12">
          <div class="content-select-moods">
            <label>Planos:</label>
            <multiselect
              group-values="data"
              group-label="category_name"
              placeholder="Escreva para pesquisar"
              label="name"
              track-by="id"
              v-model="planSelected"
              :options="plansSelect"
              :group-select="true"
              :multiple="true"
              @remove="removeHumorPlans"
            >
              <template slot="singleLabel" slot-scope="props">
                <img
                  class="option__image option--image--width"
                  v-if="props.option.picture"
                  :src="`data:image/jpg;base64,${props.option.picture}`"
                  alt="image plan"
                  title="image plan"
                />
                <span class="option__desc">
                  <span class="option__title">{{ props.option.name }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                {{ props.option.$groupLabel }}
                <img
                  class="option__image option--image--width"
                  v-if="props.option.picture"
                  :src="`data:image/jpg;base64,${props.option.picture}`"
                  alt="image plan"
                  title="image plan"
                />
                <span class="option__desc option--name">
                  <span class="option__title">{{ props.option.name }}</span>
                </span>
              </template>
            </multiselect>
          </div>
        </div>
        <div class="col-12">
          <div class="content-select-moods">
            <label>Meditações:</label>
            <multiselect
              group-values="data"
              group-label="category_name"
              placeholder="Escreva para pesquisar"
              label="name"
              track-by="id"
              v-model="meditationSelected"
              :options="meditationsSelect"
              :group-select="true"
              :multiple="true"
              @remove="removeHumorMeditation"
            >
              <template slot="singleLabel" slot-scope="props">
                <img
                  class="option__image option--image--width"
                  v-if="props.option.picture"
                  :src="`data:image/jpg;base64,${props.option.picture}`"
                  alt="image plan"
                  title="image plan"
                />
                <span class="option__desc">
                  <span class="option__title">{{ props.option.name }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                {{ props.option.$groupLabel }}
                <img
                  class="option__image option--image--width"
                  v-if="props.option.picture"
                  :src="`data:image/jpg;base64,${props.option.picture}`"
                  alt="image plan"
                  title="image plan"
                />
                <span class="option__desc option--name">
                  <span class="option__title">{{ props.option.name }}</span>
                </span>
              </template>
            </multiselect>
          </div>
        </div>
        <div class="col-12">
          <div class="content-select-moods">
            <label>Músicas:</label>
            <multiselect
              placeholder="Escreva para pesquisar"
              label="name"
              track-by="id"
              v-model="musicSelected"
              :options="musics.data"
              :multiple="true"
              @remove="removeHumorMeditationMusic"
            >
              <template slot="singleLabel" slot-scope="props">
                <img
                  class="option__image option--image--width"
                  v-if="props.option.picture"
                  :src="`data:image/jpg;base64,${props.option.picture}`"
                  alt="image plan"
                  title="image plan"
                />
                <span class="option__desc">
                  <span class="option__title">{{ props.option.name }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                {{ props.option.$groupLabel }}
                <img
                  class="option__image option--image--width"
                  v-if="props.option.picture"
                  :src="`data:image/jpg;base64,${props.option.picture}`"
                  alt="image plan"
                  title="image plan"
                />
                <span class="option__desc option--name">
                  <span class="option__title">{{ props.option.name }}</span>
                </span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Humor",
          routerName: "Humor",
        },
        {
          name: "Nova Pergunta/Resposta Humor",
          routerName: "RegisterHumorQuestions",
        },
      ],
      questionHumor: {
        id_user: "",
        ids_humor: "",
        questions: [],
        humorHasPost: [],
        humorHasPlan: [],
        humorHasMeditation: [],
        humorHasMeditationMusic: [],
      },
      question: "",
      option: "",
      arrayOptions: [],
      humorQuestionsParams: this.$route.params,
      dataProps: { module: "Humor" },
      humorSelected: null,
      postSelected: null,
      planSelected: null,
      plansSelect: [],
      meditationSelected: null,
      meditationsSelect: [],
      musicSelected: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "User/user",
      humor: "Humor/humorQuestion",
      moods: "Humor/moods",
      categoriesWithPosts: "Blog/categoriesWithPosts",
      plans: "Plans/plans",
      meditations: "Meditation/meditations",
      musics: "Meditation/musics",
    }),
    isHumorSelected() {
      return this.humor?.data?.length > 0;
    },
  },
  components: {
    Breadcrumb,
  },
  watch: {
    humor: {
      handler(newValue) {
        if (newValue.humorQuestions) {
          this.questionHumor.questions = newValue.humorQuestions;
        }
      },
    },
  },
  methods: {
    ...mapActions("Humor", [
      "registerHumorQuestions",
      "consultHumorQuestions",
      "registerHumorQuestionsOptions",
      "removeHumorQuestionsOptions",
      "registerQuestions",
      "removeQuestions",
      "consultMoodsFiltered",
      "removeHumorQuestion",
      "removeHumorPosts",
      "removeHumorPlans",
      "removeHumorMeditation",
      "removeHumorMeditationMusic",
      "setDataDefault",
    ]),
    ...mapActions({
      consultCategoriesWithPosts: "Blog/consultCategoriesWithPosts",
      consultPlans: "Plans/consultPlans",
      consultMeditations: "Meditation/consultMeditations",
      consultMusics: "Meditation/consultMusics",
    }),
    // função para salvar ou editar os conteúdos
    async handleSubmit() {
      let message = this.questionHumor.ids_humor
        ? "Perguntas e Respostas do Humor editado com sucesso!"
        : "Perguntas e Respostas do Humor cadastrado com sucesso!";

      if (this.question !== "" && this.arrayOptions.length > 0) {
        this.questionHumor.questions.push({
          question: this.question,
          data: [...this.arrayOptions],
        });
      }

      this.questionHumor.ids_humor = [
        ...this.questionHumor.ids_humor,
        ...this.getIdsHumorSelected().filter(
          (id) => !this.questionHumor.ids_humor.includes(id)
        ),
      ];

      this.questionHumor.humorHasPost = this.setValuesInObject(
        this.postSelected,
        "id_post"
      );

      this.questionHumor.humorHasPlan = this.setValuesInObject(
        this.planSelected,
        "id_plan"
      );

      this.questionHumor.humorHasMeditation = this.setValuesInObject(
        this.meditationSelected,
        "id_meditation"
      );

      this.questionHumor.humorHasMeditationMusic = this.setValuesInObject(
        this.musicSelected,
        "id_meditation_music"
      );

      await this.registerHumorQuestions(this.questionHumor);
      this.$router.push({ name: "Humor" });
      this.$swal.fire({
        icon: "success",
        html: message,
      });
    },

    // função para adicionar ou remover as perguntas/respostas
    async toggleQuestionsAndOptions(value) {
      let arrayQuestions = {
        id_user: this.user.id,
        ids_humor: this.getIdsHumorSelected(),
        question: this.question,
        options: this.arrayOptions,
      };

      const index =
        this.humor?.humorQuestions?.length > 0 &&
        this.humor.humorQuestions.findIndex(
          (item) => item.id_humor_question === value?.id_humor_question
        );

      if (index > -1 && value) {
        value.ids_humor = this.getIdsHumorSelected();

        this.$swal
          .fire({
            html: `Tem certeza que deseja deletar a
          <b style=" display: block; font-size: 24px; color: #EF0000;">${value?.question}?</b>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#EF0000",
            confirmButtonText: "SIM",
            cancelButtonText: "NÃO",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await this.removeQuestions(value);
              this.$swal.fire({
                icon: "success",
                html: `
                  <b style=" display: block; font-size: 24px; color: #EF0000;">
                    ${value?.question}
                  </b>
                  removido com sucesso!
                `,
              });
            }
          });
      } else {
        await this.registerQuestions(arrayQuestions);
      }

      this.question = "";
      this.option = "";
      this.arrayOptions = [];
    },

    getIdsHumorSelected() {
      return Array.isArray(this.humorSelected)
        ? this.humorSelected.map((item) => item.id)
        : [this.humorSelected.id];
    },

    // função para adicionar ou remover as respostas das perguntas
    async toggleAnswers(value) {
      const index = this.arrayOptions.indexOf(value);

      if (index > -1) {
        this.arrayOptions.splice(index, 1);
        if (value.id) await this.removeHumorQuestionsOptions(value);
      } else {
        this.arrayOptions.push({ option: value });
      }

      this.option = "";
    },

    // função para agrupar os conteúdos com base na suas categorias
    groupedDataByCategory(dataArray, selectArray, type) {
      dataArray.data.map((plan) => {
        if (
          !selectArray.some(
            (obj) => obj.id_category === plan[`id_${type}_category`]
          )
        ) {
          // Se não existe, cria um novo array para essa categoria
          selectArray.push({
            id_category: plan[`id_${type}_category`],
            category_name: plan.category_name,
            data: [], // Inicializa um array vazio para armazenar os dados da categoria
          });
        }
        // Adiciona o conteúdo ao array da categoria correspondente
        const category = selectArray.find(
          (obj) => obj.id_category === plan[`id_${type}_category`]
        );
        category.data.push(plan);
      });
    },

    // função para verificar se existe params na url
    // caso exista busca os dados na API com base no params
    async checkHasHumorQuestionsParams() {
      if (
        this.humorQuestionsParams &&
        Object.keys(this.humorQuestionsParams).length > 0
      ) {
        // consult humor questions
        await this.consultHumorQuestions(this.humorQuestionsParams);

        const humorNames = this.humor?.data
          ?.map((item) => item.name)
          .join(", ");

        // add link name
        this.links[1].name = `Editar Humor(es): ${humorNames}`;

        // humor
        this.questionHumor.ids_humor = this.humor?.data?.map((item) => item.id);
        this.humorSelected = this.humor?.data;

        // question
        this.questionHumor.questions = this.humor?.humorQuestions;

        // humor has post
        this.postSelected = this.humor?.humorHasPost;

        // humor has plan
        this.planSelected = this.humor?.humorHasPlan;

        // humor has meditation
        this.meditationSelected = this.humor?.humorHasMeditation;

        // humor has meditation
        this.musicSelected = this.humor?.humorHasMeditationMusic;

        // props utilizada para deletar o humor question
        this.dataProps = {
          name: `Humor(es): ${humorNames}`,
          module: "Humor",
          type: "HumorQuestions",
          ids_humor: this.questionHumor.ids_humor,
          ids_humor_question: this.questionHumor.questions.map(
            (item) => item.id_humor_question
          ),
        };
      } else {
        this.setDataDefault(["SET_HUMOR_QUESTION", {}]);
      }
    },

    // função para setar os valores no objeto com base no array e na key
    setValuesInObject(dataArray, key) {
      if (!dataArray || (Array.isArray(dataArray) && !dataArray.length)) {
        return [];
      }

      return dataArray.flatMap((item) => {
        return this.questionHumor.ids_humor.map((idHumor) => {
          // verifica se existe os ids para registrar ou editar
          // caso item.id && !item[key] então é registro (desde que a key não seja id_post)

          // caso seja falso a condição então vai ser edição
          // pega o item[key] do elemento: ex: id_post: id_post
          let obj = {
            [key]: item.id ?? item[key],
            id_humor: idHumor,
          };

          // caso true a condição então adiciona os ids para edição
          if (item?.ids?.length > 0) {
            const elementId = item.ids.find((id) =>
              Object.hasOwnProperty.call(id, idHumor)
            );
            if (elementId) {
              obj.id = elementId[idHumor];
            }
          }

          return obj;
        });
      });
    },
  },
  async mounted() {
    this.questionHumor.id_user = await this.user.id;

    await this.consultCategoriesWithPosts();
    await this.consultMusics();
    await this.consultMoodsFiltered();

    await this.consultPlans();
    this.groupedDataByCategory(this.plans, this.plansSelect, "plan");

    await this.consultMeditations();
    this.groupedDataByCategory(
      this.meditations,
      this.meditationsSelect,
      "meditation"
    );

    this.checkHasHumorQuestionsParams();
  },
};
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
  h2 {
    font-size: 24px;
    font-family: "Font Semibold";
    color: var(--black);
    text-align: left;
    padding: 30px 0px;
  }
}
.content-input-default {
  textarea {
    min-height: 100px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px) {
    margin-top: 50px;
  }
}
.content-resources-saved {
  display: flex;
  align-items: center;
  color: #515c5d;
  background: var(--white);
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: default;
  float: left;
  margin: 10px 10px 10px 0px;
  padding: 0 6px;
  p {
    font-size: 16px;
    font-family: "Font Regular";
    color: var(--gray-dark);
    margin-right: 10px;
    margin-bottom: 0;
  }
  &-icon {
    background: 0;
    border: 0;
    padding: 0;
    svg {
      width: 15px;
      height: 15px;
      fill: var(--gray-dark);
    }
  }
}
.content-select-moods {
  padding-left: 20px;
  margin-bottom: 30px;
  text-align: left;
  label {
    position: relative;
    width: 100%;
    font-size: 14px;
    font-family: "Font Semibold";
    color: var(--black);
    span {
      position: absolute;
      color: var(--red-2);
      margin-left: 3px;
    }
  }
  .multiselect {
    &__select {
      height: 100%;
    }
    .option--image--width {
      max-width: 60px;
    }
    .option--name {
      margin-left: 15px;
    }
  }
}
.content-card-questions {
  position: relative;
  background: var(--white);
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 10px 10px 10px 0px;
  padding: 15px;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
  .btn-remove {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--white);
    border: 1px solid #ccc;
    border-radius: 100%;
    padding: 0;
    transition: 500ms;
    &:hover,
    &:focus {
      cursor: pointer;
      opacity: 0.8;
    }
    svg {
      width: 15px;
      height: 15px;
      fill: var(--gray-dark);
    }
  }
  &-element {
    text-align: left;
    margin-bottom: 20px;
    h3 {
      font-size: 16px;
      font-family: "Font Bold";
      color: var(--yellow-dark);
      margin-right: 10px;
      margin-bottom: 0;
    }
  }
  &-options {
    .title {
      text-align: left;
      h4 {
        font-size: 14px;
        font-family: "Font Semibold";
        color: var(--black);
        margin-bottom: 10px;
      }
    }
    .element {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      &-option {
        display: flex;
        align-items: center;
        background: var(--white);
        border: 1px solid #ccc;
        border-radius: 4px;
        margin: 10px 10px 10px 0px;
        padding: 0 6px;
        p {
          font-size: 12px;
          font-family: "Font Regular";
          color: var(--gray-dark);
          margin-right: 10px;
          margin-bottom: 0;
        }
      }
    }
  }
}
.btn--add--questions {
  margin-top: 30px;
}
</style>
